export const RECORDING_PAGE_SIZE = 9;

export const EVENT_PAGE_SIZE = 10;
